import { 
  Grid,
  CircularProgress,
} from "@material-ui/core";


export const LoaderSuspense = () => {
    return <div
      style={{
        flexGrow: 1,
        height: "100%",
        width: "100%",
        position: "relative",
      }}
    >
      <Grid style={{ width: "100%", height: "100%" }}
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress size={80} />
      </Grid>
    </div>
  }
  